import module from 'usuario/module.js'
import template from './template.html'

export class UsuarioPermisosModulosGrupoComponent {
  onSelect = undefined
  modulo = null
  data = []
  constructor () {

  }

  $onChanges (changes) {
    if (changes.data) {
      this.totalizar()
    }
  }

  seleccionar (item) {
    this.onSelect({$event: {items: [item], seleccionado: !item.activo}})
    this.totalizar()
  }

  seleccionarToggle () {
    this.onSelect({$event: {items: this.data, seleccionado: !this.todosSeleccionados}})
    this.totalizar()
  }

  totalizar () {
    this.todosSeleccionados = this.data.every((item) => item.activo)
  }
}

module.component('usuarioPermisosModulosGrupo', {
  controller: UsuarioPermisosModulosGrupoComponent,
  template,
  bindings: {
    modulo: '<',
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/permisos/modulos/grupo/component.js